// Thin wrapper around virtual:pwa-register so the rest of the code
// never imports vite-plugin-pwa virtual modules directly.
// Safe to call in all builds: if the virtual module is missing or the
// service worker API is unavailable, it becomes a no-op.

export async function registerServiceWorker(): Promise<void> {
  if (typeof window === 'undefined') return
  if (!('serviceWorker' in navigator)) return

  try {
    const mod = await import('virtual:pwa-register')
    mod.registerSW({ immediate: true })
  } catch (err) {
    // Virtual module not available (e.g. during tests) — ignore silently.
    console.debug('[offline] registerSW skipped:', err)
  }
}
